interface Props {
  props: {
    label?: string;
    variant?: 'primary' | 'secondary';
    disabled?: boolean;
    action_id?: string;
  };
}

export function PanelButton({ props }: Props) {
  const { label, variant, disabled } = props ?? {};
  const isPrimary = variant === 'primary';
  return (
    <button
      type="button"
      disabled
      title="Panel-initiated actions are display-only in this phase."
      style={{
        padding: '6px 12px',
        fontSize: 12,
        fontWeight: 500,
        borderRadius: 6,
        border: isPrimary ? 0 : '1px solid var(--border-strong)',
        background: isPrimary ? 'var(--accent)' : 'var(--surface)',
        color: isPrimary ? '#ffffff' : 'var(--text)',
        cursor: 'not-allowed',
        opacity: disabled ? 0.5 : 0.8,
        fontFamily: 'inherit',
      }}
    >
      {label ?? 'Action'}
    </button>
  );
}
